const state = {
    menus: [],  // 菜单列表
    rights: [], // 当前模块权限
    orderIsRefresh:false, //订单是否刷新
};

const getters = {
    getMenus(state) {
        return state.menus;
    },
    getRights(state) {
        return state.rights;
    },
    canQuery(state) {
        return state.rights.indexOf('Query') > -1;
    },
    canAdd(state) {
        return state.rights.indexOf('Add') > -1;
    },
    canEdit(state) {
        return state.rights.indexOf('Edit') > -1;
    },
    canDelete(state) {
        return state.rights.indexOf('Delete') > -1;
    },
    canImport(state) {
        return state.rights.indexOf('Import') > -1;
    },
    canExport(state) {
        return state.rights.indexOf('Export') > -1;
    },
    canSubmit(state) {
        return state.rights.indexOf('Submit') > -1;
    },
    canApproval(state) {
        return state.rights.indexOf('Approval') > -1;
    },
};

const mutations = {
    setMenus(state, menus) {
        state.menus = menus;
    },
    loadRights(state, path) {
        var rights = null;
        for (var i in state.menus) {
            var menu = state.menus[i];
            if (menu.Url == path) {
                rights = menu.Rights;
                break;
            }
        }
        state.rights = rights;
    },
    orderRefreshCom(state, flag){
      state.orderIsRefresh = flag;
    }
};

const actions = {
    setMenus(context, menus) {
        context.commit('setMenus', menus);
    },
    loadRights(context, path) {
        context.commit('loadRights', path);
    },
    orderRefreshFirst(context, flag) {
      context.commit('orderRefreshCom', flag);
    }
};

export default {
    namespaced: true,//用于在全局引用此文件里的方法时标识这一个的文件名
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/rights.js